module.exports = __webpack_public_path__ + "img/userLogo23.4ced8f3a.jpg";